import React, { useCallback, useState } from "react";
import { Banner, Card, Collapsible, FormLayout, Icon, Modal, TextContainer } from "@shopify/polaris";
import { CsI18n } from "../../shared/csI18n/csI18n";
import CsEditor from "./CsEditor";
import Env from "../../Env";
import { ChevronDownMinor, ChevronUpMinor } from "@shopify/polaris-icons";
import { GenerationDraftActions, GenerationEnvSwitcher } from "./GenerationActions";

const DraftDebug = props => {
  const { rawHtmlOpen, rawHtmlControl, draftContent, handleToggleRawHtml } = props;

  return (
    !Env.isDevMode() ? '' :
      <Card.Section sectioned title={'Raw HTML'} actions={[{
        content: <Icon source={rawHtmlOpen ? ChevronUpMinor : ChevronDownMinor} />,
        ariaControls: rawHtmlControl,
        onAction: handleToggleRawHtml
      }]}>
        <Collapsible id={rawHtmlControl} open={rawHtmlOpen}>
          <pre className={'editor-raw-html'}>{draftContent}</pre>
        </Collapsible>
      </Card.Section>
  );
}

const GenerationTabContentDraft = props => {
  const {
    pageType, handleChangeEnv,
    preDraftContent, draftContent,
    draftUnSavedNotice,
    uploadToken, mentionPool,
    handleEditorChange, handleEditorInitialized, handleDiscardChange,
    hasTemplate, modalTemplate, handleToggleModalTemplate, handleApplyTemplate,
    saving, handleSavePage,
    rawHtmlOpen, rawHtmlControl, handleToggleRawHtml,
  } = props;

  const [editorReady, setEditorReady] = useState(false),
    handleEditorReady = useCallback(ckEditor => {
      handleEditorInitialized(ckEditor, pageType);
      setEditorReady(true);
    }, [handleEditorInitialized, pageType]);

  const switcher =
    <GenerationEnvSwitcher isProd={false} pageType={pageType} handleChangeEnv={handleChangeEnv} />;
  const actions =
    <GenerationDraftActions
      pageType={pageType} saving={saving} editorReady={editorReady}
      hasTemplate={hasTemplate} handleToggleModalTemplate={handleToggleModalTemplate}
      handleDiscardChange={handleDiscardChange} handleSavePage={handleSavePage}
    />;

  return (
    <>
      <Card.Section sectioned>
        <FormLayout>
          {switcher}
          {draftUnSavedNotice && <div><Banner status="warning"><CsI18n>Unsaved changes</CsI18n></Banner></div>}
        </FormLayout>
      </Card.Section>

      <Card.Section>
        <Banner status='info'>
          {CsI18n.t('To insert a predefined field, enter {')}
        </Banner>
      </Card.Section>

      <Card.Section sectioned>{actions}</Card.Section>

      <Card.Section>
        <CsEditor
          preDraftContent={preDraftContent}
          pageType={pageType} draftContent={draftContent} saving={saving}
          uploadToken={uploadToken} mentionPool={mentionPool}
          handleEditorChange={handleEditorChange} handleEditorReady={handleEditorReady}
        />
      </Card.Section>

      <Card.Section>{switcher}</Card.Section>
      <Card.Section sectioned>{actions}</Card.Section>

      <DraftDebug
        rawHtmlOpen={rawHtmlOpen} rawHtmlControl={rawHtmlControl}
        draftContent={draftContent}
        handleToggleRawHtml={handleToggleRawHtml}
      />

      <Modal
        open={modalTemplate}
        title={CsI18n.t('Use template')}
        onClose={handleToggleModalTemplate}
        primaryAction={{ content: CsI18n.t('Replace'), onAction: handleApplyTemplate, destructive: true }}
        secondaryActions={[{ content: CsI18n.t('Cancel'), onAction: handleToggleModalTemplate }]}
      >
        <Modal.Section>
          <TextContainer>
            <p><CsI18n>Your current draft content will be replaced with template content.</CsI18n></p>
          </TextContainer>
        </Modal.Section>
      </Modal>
    </>
  );
}

export default GenerationTabContentDraft;
